// Clean single implementation of navigation items
import {
  LayoutGrid,
  Calendar,
  Building2,
  Users,
  CreditCard,
  MessageSquare,
  Settings,
  HelpCircle,
  Megaphone,
  BarChart3,
  Tag,
} from "lucide-react";
import * as localService from "../services/localService";
import { Constants, RoleConstants } from "./constants";
import { FeatureAccess } from "./featureAccessControl";

export function getNavigationItems() {
  const userData = localService.getUser();
  const userRole = userData?.organizationRole?.code || userData?.role || "";

  const hasClientsUsersAccess = FeatureAccess.hasClientsUsersAccess(userData);
  const hasOffersDiscountsAccess = FeatureAccess.hasOffersDiscountsAccess(userData);
  const hasAnnouncementsAccess = FeatureAccess.hasAnnouncementsAccess(userData);
  const isCustomer = RoleConstants.isRoleInGroup(userRole, "HOST_CUSTOMER_ROLES");

  if (isCustomer) {
    const isHostCustomerOwner =
      userRole === "Host Corporate Customer Owner" ||
      userRole === "ROLE_HOST_CUSTOMER_OWNER" ||
      userRole?.includes("Host Corporate Customer Owner");

    const baseNavItems = [
      { name: "Dashboard", path: "/host/customer-dashboard", icon: LayoutGrid },
      { name: "Feed", path: "/host/feed", icon: LayoutGrid },
      { name: "Bookings", path: "/host/my-bookings", icon: Calendar },
      { name: "Communication Center", path: "/host/messages", icon: MessageSquare },
      { name: "Book a Space", path: "/host/book-space", icon: Constants.PlusIcon || Calendar },
      { name: "Floor Plan", path: "/host/floor-plan", icon: Constants.LocationIcon || Building2 },
    ];

    if (hasClientsUsersAccess) {
      baseNavItems.push({ name: "Users", path: "/host/clients", icon: Users });
    }

    return {
      mainNavItems: baseNavItems,
      toolsItems: [
        { name: "Profile", path: "/host/customer-profile", icon: Constants.UserIcon || Settings },
        // { name: "Help", path: "/host/customer-help", icon: HelpCircle },
      ],
    };
  }

  const mainNavItems = [
    { name: "Dashboard", path: "/host/dashboard", icon: LayoutGrid },
    { name: "Bookings", path: "/host/calendar", icon: Calendar },
    { name: "Spaces & Services", path: "/host/spaces", icon: Building2 },
    { name: "Users", path: "/host/clients", icon: Users },
    { name: "Billing & Payments", path: "/host/invoice", icon: CreditCard },
    { name: "Offers & Discounts", path: "/host/offers-discounts", icon: Tag },
  ];

  const toolsItems = [
    { name: "Reports & Analytics", path: "/host/analytics", icon: BarChart3 },
    { name: "Communication Center", path: "/host/messages", icon: MessageSquare },
    { name: "Announcements", path: "/host/announcements", icon: Megaphone },

    { name: "Settings", path: "/host/settings", icon: Settings },
  ];

  const filteredMainNavItems = mainNavItems.filter(item => {
    if (item.path === "/host/clients" && !hasClientsUsersAccess) return false;
    if (item.path === "/host/offers-discounts" && !hasOffersDiscountsAccess) return false;
    return true;
  });

  const filteredToolsItems = toolsItems.filter(item => {
    if (item.path === "/host/announcements" && !hasAnnouncementsAccess) return false;
    return true;
  });

  return { mainNavItems: filteredMainNavItems, toolsItems: filteredToolsItems };
}
